$(function () {

    var themes = {
        HIGH_CONTRAST: 'high-contrast',
        NORMAL: 'normal'
    };

    var currentTheme = localStorage.getItem('theme') || null;

    if (currentTheme) {
        $(document.documentElement).attr('data-theme', currentTheme);
        if (currentTheme === themes.NORMAL) {
            $('.accessibility-toggle').removeClass('icon-highContrastEnabled').addClass('icon-highContrastDisabled');
            $('.toggle-high-contrast')
                .attr('aria-pressed', 'false')
                .attr('aria-label', _s ? _s('Normal Mode Selected') : 'Normal Mode Selected');
        } else {
            $('.accessibility-toggle').removeClass('icon-highContrastDisabled').addClass('icon-highContrastEnabled');
            $('.toggle-high-contrast')
                .attr('aria-pressed', 'true')
                .attr('aria-label', _s ? _s('High contrast Mode Selected') : 'High contrast Mode Selected');
        }
    }

    $('.toggle-high-contrast').on('click', function () {

        var currentTheme = $(document.documentElement).attr('data-theme'),
            $toggle = $(this);

        if (currentTheme === themes.NORMAL) {
            $(document.documentElement).attr('data-theme', themes.HIGH_CONTRAST);
            $('.accessibility-toggle').removeClass('icon-highContrastDisabled').addClass('icon-highContrastEnabled');
            $toggle
                .attr('aria-label', _s ? _s('High contrast Mode Selected') : 'High contrast Mode Selected')
                .attr('aria-pressed', 'true');
            localStorage.setItem('theme', themes.HIGH_CONTRAST);
        } else {
            $(document.documentElement).attr('data-theme', themes.NORMAL);
            $('.accessibility-toggle').removeClass('icon-highContrastEnabled').addClass('icon-highContrastDisabled');
            $toggle
                .attr('aria-label', _s ? _s('Normal Mode Selected') : 'Normal Mode Selected')
                .attr('aria-pressed', 'false');
            localStorage.setItem('theme', themes.NORMAL);
        }
    });

});